module.exports = __webpack_public_path__ + "img/about-3.88404d88.png";